/* MBroidery personalisatie configurator voor accessoires - los asset */
(function(){
  function init(root){
    if(root.dataset.mbpInit) return; root.dataset.mbpInit = '1';
    var BASE = parseFloat(root.dataset.base) || 0;
    var GIFT = parseFloat(root.dataset.gift) || 0;
    var EIGENADD = parseFloat(root.dataset.eigenadd) || 0;
    var EIGENVID = root.dataset.eigenvid || '';
    function eigenAan(step){ var s=step.querySelector('.txtsub'); if(!s || s.classList.contains('hide')) return false; var f=s.querySelector('.mbp-font'); if(!f) return false; var o=f.options[f.selectedIndex]; return o && o.getAttribute('data-eigen') ? true : false; }
    var variants = [], options = [], threadsRaw = '';
    try { variants = JSON.parse(root.querySelector('[data-mbp-variants]').textContent || '[]'); } catch(e){ variants = []; }
    try { options = JSON.parse(root.querySelector('[data-mbp-options]').textContent || '[]'); } catch(e){ options = []; }
    try { threadsRaw = JSON.parse(root.querySelector('[data-mbp-threads]').textContent || '""'); } catch(e){ threadsRaw = ''; }

    var threads = (threadsRaw || '').split('\n').map(function(l){ return l.trim(); }).filter(Boolean).map(function(l){
      var parts = l.split('|'); var name = (parts[0]||'').trim(); var val = (parts[1]||'').trim();
      var isImg = /^https?:\/\//.test(val);
      return { name: name, hex: isImg ? '' : (val||'#eee'), img: isImg ? val : '' };
    });

    var KLEURMAP = {
      'zwart':'#1c1c1c','donkergrijs':'#5b5b5b','sportgrijs':'#b9b9b9','grijs':'#9a9a9a','lichtgrijs':'#cfcfcf',
      'donkerblauw':'#22314f','royaal blauw':'#2f5fb0','royaalblauw':'#2f5fb0','lichtblauw':'#8db8e0','blauw':'#3a6bb0','nachtblauw':'#1f2a44','denim':'#4a6a8a',
      'donkergroen':'#22492d','groen':'#3f7d48','lichtgroen':'#8bbf6f','kaki':'#7a7a52','sand':'#e3d0ab',
      'bordeaux':'#5c1e29','rood':'#a4262c','terracotta':'#b5643f','toffee':'#8a5a34','bruin':'#6b4a34',
      'roze':'#e78bb0','lichtroze':'#f4c9dd','oud roze':'#d29aad','lila':'#b79ec9','paars':'#5b2a6b',
      'geel':'#e6c33a','oranje':'#dd6a2c','natuur':'#e9e2d3','wit':'#f4f4f2','beige':'#d9c9ac'
    };
    function kleurHex(naam){ var k=(naam||'').toLowerCase().trim(); return KLEURMAP[k] || '#d8c4cf'; }
    var swatchMap = {};
    try { var _sw = root.querySelector('[data-mbp-swatches]'); if(_sw){ swatchMap = JSON.parse(_sw.textContent || '{}') || {}; } } catch(e){ swatchMap = {}; }
    function swatchColor(naam){ var h = swatchMap[naam]; return (h && String(h).trim()) ? h : kleurHex(naam); }
    function money(n){ return '€ ' + n.toFixed(2).replace('.', ','); }
    var stockmap = {};
    try { var _st = root.querySelector('[data-mbp-stock]'); if(_st){ stockmap = JSON.parse(_st.textContent || '{}') || {}; } } catch(e){ stockmap = {}; }
    var STOCKDREMPEL = parseInt(root.dataset.stockdrempel, 10) || 5;
    function renderStock(vid){
      var el = root.querySelector('#mbp-stock'); if(!el) return;
      var s = vid ? stockmap[vid] : null;
      if(s && s.m && s.p === 'deny' && s.q > 0 && s.q <= STOCKDREMPEL){ el.textContent = 'Nog ' + s.q + ' beschikbaar'; el.style.display=''; }
      else { el.textContent=''; el.style.display='none'; }
    }
    function isColorOpt(name){ return /kleur|colour|color/i.test(name||''); }
    function optVal(v, pos){ return pos===1 ? v.option1 : (pos===2 ? v.option2 : v.option3); }

    var state = { sel: {}, qty: 1, gift: false };
    // standaard: eerste waarde per optie
    options.forEach(function(o){ state.sel[o.position] = (o.values && o.values[0]) || null; });

    // eerste variantfoto per kleurwaarde onthouden
    function imgForColor(pos, val){
      var v = variants.find(function(x){ return optVal(x,pos)===val && x.featured_image && x.featured_image.src; });
      return v ? v.featured_image.src : '';
    }

    var body = root.querySelector('#mbp-optionbody');
    function renderOptions(){
      body.innerHTML = '';
      options.forEach(function(o){
        var lbl = document.createElement('div'); lbl.className='sublabel'; lbl.textContent=o.name; body.appendChild(lbl);
        if(isColorOpt(o.name)){
          var row=document.createElement('div'); row.className='swrow';
          o.values.forEach(function(val){
            var img=imgForColor(o.position,val);
            var d=document.createElement('div'); d.className='sw'+(state.sel[o.position]===val?' sel':''); d.dataset.val=val;
            d.style.background=swatchColor(val);
            d.innerHTML='<span>'+val+'</span>'; d.title=val;
            d.onclick=function(){ pickOption(o.position,val,img); };
            row.appendChild(d);
          });
          body.appendChild(row);
        } else {
          var cards=document.createElement('div'); cards.className='cards';
          o.values.forEach(function(val){
            var avail=variants.some(function(x){ return optVal(x,o.position)===val && matchOther(x,o.position) && x.available; });
            var c=document.createElement('div'); c.className='card'+(avail?'':' soldout')+(state.sel[o.position]===val?' sel':''); c.dataset.val=val;
            c.innerHTML='<div class="ct">'+val+'</div>';
            if(avail){ c.onclick=function(){ pickOption(o.position,val,''); }; }
            cards.appendChild(c);
          });
          body.appendChild(cards);
        }
      });
      var _sd=document.createElement('div'); _sd.className='mbp-stocklow'; _sd.id='mbp-stock'; _sd.style.display='none'; body.appendChild(_sd);
      if(root.dataset.uitvoeringinfo){ var _ui=document.createElement('div'); _ui.className='info'; _ui.style.marginTop='12px'; var _uii=document.createElement('span'); _uii.className='i'; _uii.textContent='i'; var _uit=document.createElement('span'); _uit.textContent=root.dataset.uitvoeringinfo; _ui.appendChild(_uii); _ui.appendChild(_uit); body.appendChild(_ui); }
    }
    function matchOther(v, pos){
      return options.every(function(o){ return o.position===pos ? true : optVal(v,o.position)===state.sel[o.position]; });
    }
    function pickOption(pos,val,img){
      state.sel[pos]=val;
      if(img){ var mi=root.querySelector('#mbp-mainimg'); if(mi) mi.src=img; }
      // controleer of huidige combinatie nog bestaat, anders corrigeer andere opties
      if(!huidigeVariant()){
        options.forEach(function(o){
          if(o.position===pos) return;
          var ok=variants.find(function(x){ return optVal(x,pos)===val && x.available; });
          if(ok) state.sel[o.position]=optVal(ok,o.position);
        });
      }
      renderOptions(); recalc();
    }
    function huidigeVariant(){ return variants.find(function(x){ return options.every(function(o){ return optVal(x,o.position)===state.sel[o.position]; }); }); }

    // thumbnails
    root.querySelectorAll('.thumbs img').forEach(function(t){
      t.onclick=function(){ root.querySelector('#mbp-mainimg').src=t.dataset.full; root.querySelectorAll('.thumbs img').forEach(function(x){x.classList.remove('sel');}); t.classList.add('sel'); };
    });

    // draadkleuren
    root.querySelectorAll('.mbp-threads').forEach(function(tcs){
      threads.forEach(function(t, idx){
        var d=document.createElement('div'); d.className='tc'+(idx===0?' sel':''); d.dataset.name=t.name;
        if(t.img){ d.style.backgroundImage='url('+t.img+')'; } else { d.style.background=t.hex; }
        d.title=t.name; tcs.appendChild(d);
      });
      var nameEl = tcs.parentElement.querySelector('.mbp-threadname');
      if(nameEl && threads[0]) nameEl.textContent = 'Kleur draad - ' + threads[0].name;
      tcs.querySelectorAll('.tc').forEach(function(tc){
        tc.onclick=function(){
          tcs.querySelectorAll('.tc').forEach(function(x){x.classList.remove('sel');}); tc.classList.add('sel');
          if(nameEl) nameEl.textContent='Kleur draad - '+tc.dataset.name;
          var pv=tcs.parentElement.querySelector('.mbp-pv'); if(pv && tc.style.backgroundColor) pv.style.color=tc.style.backgroundColor;
        };
      });
    });

    // kleurfamilies (bloemenletter)
    var familiesRaw=''; try{ familiesRaw=JSON.parse(root.querySelector('[data-mbp-families]').textContent||'""'); }catch(e){ familiesRaw=''; }
    var families=(familiesRaw||'').split('\n').map(function(l){return l.trim();}).filter(Boolean).map(function(l){ var p=l.split('|'); return {name:(p[0]||'').trim(), hex:(p[1]||'#eee').trim()}; });
    root.querySelectorAll('.mbp-families').forEach(function(fcs){
      families.forEach(function(f, idx){ var d=document.createElement('div'); d.className='tc'+(idx===0?' sel':''); d.dataset.name=f.name; d.style.background=f.hex; d.title=f.name; fcs.appendChild(d); });
      var nameEl=fcs.parentElement.querySelector('.mbp-familyname'); if(nameEl && families[0]) nameEl.textContent='Hoofdkleur - '+families[0].name;
      fcs.querySelectorAll('.tc').forEach(function(tc){ tc.onclick=function(){ fcs.querySelectorAll('.tc').forEach(function(x){x.classList.remove('sel');}); tc.classList.add('sel'); if(nameEl) nameEl.textContent='Hoofdkleur - '+tc.dataset.name; }; });
    });

    // personalisatie-opties
    root.querySelectorAll('.optrow').forEach(function(row){
      var step=row.closest('[data-step]');
      row.querySelectorAll('.opt').forEach(function(o){
        o.onclick=function(){
          row.querySelectorAll('.opt').forEach(function(x){x.classList.remove('sel');}); o.classList.add('sel');
          ['.txtsub','.logosub','.bloemsub'].forEach(function(cls){ var e=step.querySelector(cls); if(e) e.classList.add('hide'); });
          var map={tekst:'.txtsub',logo:'.logosub',bloem:'.bloemsub'};
          var show=map[o.dataset.key]; if(show){ var e=step.querySelector(show); if(e) e.classList.remove('hide'); }
          var pick=step.querySelector('.pick'); if(pick) pick.textContent=o.dataset.name;
          recalc();
        };
      });
    });

    // tekst-preview
    root.querySelectorAll('.txtsub').forEach(function(sub){
      var pv=sub.querySelector('.mbp-pv'), input=sub.querySelector('.tin'), heart=sub.querySelector('.mbp-heart');
      function renderpv(){ if(!pv||!input) return; var base=input.value||''; if(heart&&heart.checked) base+=' ♥'; pv.textContent=base||' '; }
      if(input) input.addEventListener('input', renderpv);
      if(heart) heart.addEventListener('change', renderpv);
      var fsel=sub.querySelector('.mbp-font'); if(fsel){ fsel.addEventListener('change', function(){ var o=this.options[this.selectedIndex]; pv.style.fontFamily=o.getAttribute('data-font'); pv.style.fontStyle=o.getAttribute('data-style')||'normal'; pv.style.fontWeight=o.getAttribute('data-weight')||'400'; var ew=sub.querySelector('.eigenwrap'); if(ew){ ew.classList.toggle('hide', !o.getAttribute('data-eigen')); } recalc(); }); }
    });

    // plaats borduren
    root.querySelectorAll('.plaatsrow .popt').forEach(function(o){ o.onclick=function(){ var row=o.closest('.plaatsrow'); row.querySelectorAll('.popt').forEach(function(x){x.classList.remove('sel');}); o.classList.add('sel'); var pk=root.querySelector('#mbp-plaatspick'); if(pk) pk.textContent=o.dataset.name; }; });
    (function(){ var pk=root.querySelector('#mbp-plaatspick'); var sel=root.querySelector('.plaatsrow .popt.sel'); if(pk && sel) pk.textContent=sel.dataset.name; })();

    // cadeau
    var giftcard=root.querySelector('#mbp-giftcard');
    if(giftcard) giftcard.onclick=function(){ state.gift=!state.gift; this.classList.toggle('sel', state.gift); var gp=root.querySelector('#mbp-giftpick'); if(gp) gp.textContent=state.gift?'Ja':''; recalc(); };

    // qty
    root.querySelector('#mbp-plus').onclick=function(){ state.qty++; recalc(); };
    root.querySelector('#mbp-min').onclick=function(){ if(state.qty>1){ state.qty--; recalc(); } };

    // accordeon van de stappen
    root.querySelectorAll('.stephead').forEach(function(h){ h.onclick=function(e){
      if(e.target.closest('.giftcard')) return;
      var s=h.parentElement, isOpen=s.classList.contains('open');
      root.querySelectorAll('.step').forEach(function(x){x.classList.remove('open');}); if(!isOpen) s.classList.add('open');
    };});

    function optiesTotaal(){ var add=0; root.querySelectorAll('.optrow .opt.sel').forEach(function(o){ add+=parseFloat(o.dataset.add||0); }); root.querySelectorAll('[data-plek]').forEach(function(step){ if(eigenAan(step)) add+=EIGENADD; }); if(state.gift) add+=GIFT; return add; }
    function recalc(){
      var add=optiesTotaal(); var per=BASE+add;
      root.querySelector('#mbp-perstuk').textContent=money(per);
      root.querySelector('#mbp-headprice').textContent=money(BASE);
      root.querySelector('#mbp-optline').textContent= add>0 ? ('waarvan '+money(add)+' aan personalisatie') : 'basisprijs, nog geen personalisatie';
      root.querySelector('#mbp-qty').textContent=state.qty;
      var km=root.querySelector('#mbp-km'); if(km){ km.textContent=options.map(function(o){ return state.sel[o.position]; }).filter(Boolean).join(' · '); }
      var v=huidigeVariant(); var ok=v && v.available!==false;
      renderStock(v ? v.id : null);
      var addBtn=root.querySelector('#mbp-add'); addBtn.disabled=!ok;
      addBtn.textContent= ok ? 'In je winkelmandje' : 'Even niet beschikbaar';
    }

    function verzamelPlek(plek){
      var step=root.querySelector('[data-plek="'+plek+'"]'); if(!step) return {};
      var sel=step.querySelector('.optrow .opt.sel'); var key=sel?sel.dataset.key:'niks';
      var props={}; var label=plek.charAt(0).toUpperCase()+plek.slice(1);
      if(key==='niks') return props;
      props[label]=sel.dataset.name;
      if(key==='tekst'){
        var sub=step.querySelector('.txtsub');
        props[label+' tekst']=sub.querySelector('.tin').value;
        var f=sub.querySelector('.mbp-font'); if(f) props[label+' lettertype']=f.value;
        var t=sub.querySelector('.mbp-threads .tc.sel'); if(t) props[label+' draadkleur']=t.dataset.name;
        var h=sub.querySelector('.mbp-heart'); if(h && h.checked) props[label+' hartje']='Ja';
      } else if(key==='logo'){
        var lsub=step.querySelector('.logosub');
        var lt=lsub ? lsub.querySelector('.mbp-threads .tc.sel') : null; if(lt) props[label+' draadkleur']=lt.dataset.name;
      } else if(key==='bloem'){
        var bsub=step.querySelector('.bloemsub');
        if(bsub){
          var le=bsub.querySelector('.mbp-letter'); if(le && le.value) props[label+' letter']=le.value;
          var bf=bsub.querySelector('.mbp-families .tc.sel'); if(bf) props[label+' hoofdkleur']=bf.dataset.name;
        }
      }
      return props;
    }

    root.querySelector('#mbp-add').onclick=function(){
      var v=huidigeVariant(); if(!v) return;
      var props={};
      var plekken=[]; root.querySelectorAll('[data-plek]').forEach(function(s){ plekken.push(s.dataset.plek); });
      plekken.forEach(function(plek){ Object.assign(props, verzamelPlek(plek)); });
      var extra=root.querySelector('.mbp-extra'); if(extra && extra.value) props['Extra info']=extra.value;
      var pp=root.querySelector('.plaatsrow .popt.sel'); if(pp) props['Plaats borduren']=pp.dataset.name;

      var files=[];
      plekken.forEach(function(plek){
        var step=root.querySelector('[data-plek="'+plek+'"]'); if(!step) return;
        var lbl=plek.charAt(0).toUpperCase()+plek.slice(1);
        var sel=step.querySelector('.optrow .opt.sel');
        if(sel && sel.dataset.key==='logo'){
          var sub=step.querySelector('.logosub'); var fi=sub?sub.querySelector('.mbp-file'):null;
          if(fi && fi.files && fi.files[0]){ files.push({ name: lbl+' logo bestand', file: fi.files[0] }); }
        }
        if(eigenAan(step)){
          var ew=step.querySelector('.eigenwrap'); var ei=ew?ew.querySelector('.mbp-eigen-file'):null;
          if(ei && ei.files && ei.files[0]){ files.push({ name: lbl+' lettertype voorbeeld', file: ei.files[0] }); }
        }
      });

      var addons=[];
      plekken.forEach(function(plek){
        var step=root.querySelector('[data-plek="'+plek+'"]'); if(!step) return;
        var lbl=plek.charAt(0).toUpperCase()+plek.slice(1);
        var sel=step.querySelector('.optrow .opt.sel'); if(!sel) return;
        var vid=sel.dataset.vid; var add=parseFloat(sel.dataset.add||0);
        if(vid && add>0){ addons.push({ id: parseInt(vid,10), quantity: state.qty, properties: { Plek: lbl } }); }
        if(eigenAan(step) && EIGENVID && EIGENADD>0){ addons.push({ id: parseInt(EIGENVID,10), quantity: state.qty, properties: { Plek: lbl + ' eigen lettertype' } }); }
      });
      if(state.gift){ var gv=root.dataset.giftvid; if(gv){ addons.push({ id: parseInt(gv,10), quantity: state.qty, properties: { Plek: 'Cadeauverpakking' } }); } }

      var btn=this; btn.disabled=true; btn.textContent='Toevoegen...';
      function addMain(){
        if(files.length){
          var fd=new FormData();
          fd.append('id', v.id); fd.append('quantity', state.qty);
          Object.keys(props).forEach(function(k){ fd.append('properties['+k+']', props[k]); });
          files.forEach(function(f){ fd.append('properties['+f.name+']', f.file); });
          return fetch('/cart/add.js', { method:'POST', body: fd });
        }
        return fetch('/cart/add.js', { method:'POST', headers:{'Content-Type':'application/json'}, body: JSON.stringify({ items:[{ id:v.id, quantity:state.qty, properties:props }] }) });
      }
      function addAddons(){ if(!addons.length) return Promise.resolve(); return fetch('/cart/add.js', { method:'POST', headers:{'Content-Type':'application/json'}, body: JSON.stringify({ items: addons }) }); }
      addMain().then(function(){ return addAddons(); }).then(function(){ window.location.href='/cart'; }).catch(function(){ btn.disabled=false; btn.textContent='In je winkelmandje'; alert('Er ging iets mis, probeer opnieuw.'); });
    };

    renderOptions(); recalc();
  }
  function boot(){ document.querySelectorAll('.mbperso-acc').forEach(init); }
  if(document.readyState==='loading'){ document.addEventListener('DOMContentLoaded', boot); } else { boot(); }
})();
